import { NamedProperty, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useCatalogueLookupsApi } from "../../api/catalogue-api/lookups/useCatalogueLookupsApi";
import { sortVersionTypesByName } from "../../utils/sortVersionTypesByName";
import { DataHooksQueryKey } from "./DataHooksQueryKey";

export const useTrailerVersionTypes = (): SprintQueryResult<NamedProperty[]> => {
    const { getTrailerVersionTypes } = useCatalogueLookupsApi();

    return useSprintQuery<NamedProperty[]>({
        queryKey: [DataHooksQueryKey.TrailerVersionTypes],
        queryFn: async (): Promise<NamedProperty[]> => {
            const response = await getTrailerVersionTypes();
            return sortVersionTypesByName(response.versions);
        }
    });
};
